module.exports = __webpack_public_path__ + "img/magic-touch.3cfe11f0.svg";